import { render } from "./index.vue?vue&type=template&id=25f26c0e"
const script = {}

import exportComponent from "E:\\work\\高大\\pps\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__